/**
 * Sozlamalar' own sidebar (spec §2, §11): seven sections at seven routes.
 *
 * The sidebar is shown to the owner and the platform admin; the two sections a branch manager
 * also needs (Jamoa va filiallar, Taqsimlash qoidalari) are visible to the manager too. The
 * router gates each route by the same role, so a hidden link and a refused page cannot disagree.
 */
import type { TranslationKey } from "@/i18n";
import type { Role } from "@/api/types";

export interface SettingsNavItem {
  key: string;
  labelKey: TranslationKey;
  to: string;
  roles: readonly Role[];
}

const OWNER: readonly Role[] = ["owner"];
const MANAGER_AND_OWNER: readonly Role[] = ["branch_manager", "owner"];

export const SETTINGS_NAV: readonly SettingsNavItem[] = [
  { key: "agency", labelKey: "settings.nav.agency", to: "/sozlamalar/agentlik", roles: OWNER },
  { key: "team", labelKey: "settings.nav.team", to: "/sozlamalar/jamoa", roles: MANAGER_AND_OWNER },
  { key: "distribution", labelKey: "settings.nav.distribution", to: "/sozlamalar/taqsimlash", roles: MANAGER_AND_OWNER },
  { key: "pricing", labelKey: "settings.nav.pricing", to: "/sozlamalar/narx", roles: OWNER },
  { key: "operators", labelKey: "settings.nav.operators", to: "/sozlamalar/turoperatorlar", roles: OWNER },
  { key: "catalog", labelKey: "settings.nav.catalog", to: "/sozlamalar/katalog", roles: OWNER },
  { key: "documents", labelKey: "settings.nav.documents", to: "/sozlamalar/hujjatlar", roles: OWNER },
];

/** The sections a role may open. An empty list means the role has no settings at all. */
export function settingsNavFor(role: Role | undefined): readonly SettingsNavItem[] {
  if (role === undefined) {
    return [];
  }
  return SETTINGS_NAV.filter((item) => item.roles.includes(role));
}
